module.exports = __webpack_public_path__ + "img/8a03d84.png";